import { createAction, props } from '@ngrx/store';
import type { OnlineSession } from '../models/user-activity.model';

export const loadOnlineSessions = createAction(
  '[User Activity] Load Online Sessions'
);

export const loadOnlineSessionsSuccess = createAction(
  '[User Activity] Load Online Sessions Success',
  props<{ sessions: OnlineSession[] }>()
);

export const loadOnlineSessionsFailure = createAction(
  '[User Activity] Load Online Sessions Failure',
  props<{ error: string }>()
);

/** The login-history tab (re)loaded: sign-ins counted so far are on screen. */
export const loginHistoryReloaded = createAction(
  '[User Activity] Login History Reloaded'
);
